import type * as React from 'react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/ui/card';
import { SeedingReport } from './seeding-report';

/**
 * «Посев» в Excel по образцу клиента: строка на публикацию, экран статистики
 * картинкой прямо в ячейке, без итогов — суммы считает тот, кто открыл файл.
 *
 * Не путать с еженедельным «Отработано» (features/seeding-report): тот
 * собирает копии ролика в разных пабликах одним посевом и уезжает в Word.
 */
export function SeedingSheetReportCard(): React.ReactElement {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Посев в таблице</CardTitle>
        <CardDescription>
          Для клиента по его образцу: строка на каждое размещение — паблик, формат, просмотры,
          охваты и скрин статистики в ячейке, без группировки и итогов. Копии одного ролика
          одним посевом с топом — это «Отработано».
        </CardDescription>
      </CardHeader>
      <CardContent>
        <SeedingReport />
      </CardContent>
    </Card>
  );
}
